export default class EdgeService {
    #resolver = {};

    constructor() {
        this._registerMessageCallback();
    }

    sampleEdge(modelId, branchId, samples, point) {
        return new Promise((resolve, reject) => {
            const correlationId = generateUUID();
            wv.sendTextMessage(text_sampleEdge, correlationId, modelId, branchId, samples, serializeV3(point, 9));
            this.#resolver[correlationId] = {
                resolve,
                reject
            }
        });
    }

    _resolveSampleEdge(correlationId, distance, samples, samplePoints) {
        if (!this.#resolver[correlationId]) {
            console.warn("Response received without matching request: ", correlationId);
            return;
        }

        this.#resolver[correlationId].resolve({distance, samples, samplePoints});
        delete this.#resolver[correlationId];
    }

    _registerMessageCallback() {
        wv.communicator.addEventListener(text_sampleEdge, itemArr => {
            const samples = itemArr[3] ? parseInt(itemArr[3]) : 0;
            const samplePoints = [];

            const pointData = itemArr.slice(4).map(v => parseFloat(v));
            for (let index = 0; index < samples; index++) {
                samplePoints.push(new THREE.Vector3(pointData[index * 3], pointData[index * 3 + 1], pointData[index * 3 + 2]));
            }

            this._resolveSampleEdge(itemArr[0], parseFloat(itemArr[1]), samples, samplePoints);
        });
    }
}
